var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFeedbackNotLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    className: "shrink-0 size-4",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.25 8A2.25 2.25 0 0 0 17 5.75h-1.25v8.5H17A2.25 2.25 0 0 0 19.25 12zM9.03 5.75c-.92 0-1.746.56-2.088 1.414l-1.6 4a2.25 2.25 0 0 0 2.09 3.086H10a.75.75 0 0 1 .642 1.136l-1.382 2.303a1.03 1.03 0 0 0 1.688 1.174l3.302-4.128V5.75zM20.75 12A3.75 3.75 0 0 1 17 15.75h-1.64l-3.24 4.05c-.48.601-1.207.95-1.976.95-1.967 0-3.18-2.146-2.169-3.832l.7-1.168H7.431c-2.653 0-4.467-2.68-3.481-5.143l1.6-4A3.75 3.75 0 0 1 9.03 4.25H17A3.75 3.75 0 0 1 20.75 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFeedbackNotLike);
export default __webpack_public_path__ + "static/media/user-feedback-not-like.094f85dd1704aa6fdc1d04689534615c.svg";
export { ForwardRef as ReactComponent };